import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { SettingsAnnouncementsComponent } from '@irb/irb-settings/settings-announcements/settings-announcements.component';
import { UtilityService } from '@irb-common/services/utility.service';
import { CheckboxCellComponent } from '@irb-common/components/grid/renderers/checkbox.cell.component';
import { TruncateTooltipCellComponent } from '@irb-common/components/grid/renderers/truncatetooltip.cell.component';
import { PortColFormatterComponent } from '@irb-common/components/irebal-ag-grid-ent-avatar/portcolformatter.component';

@Injectable({
    providedIn: 'root'
})
export class SettingsAnnouncementsGridLayoutService implements GridLayoutService<SettingsAnnouncementsComponent> {
    constructor(private util: UtilityService) {}

    getFrameworkComponents() {
        return {
            "CheckboxCellComponent": CheckboxCellComponent,
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent,
            "cellRendererFormatter": PortColFormatterComponent
        };
    }

    getColumnDefs(parent: SettingsAnnouncementsComponent) {
        return [{
            headerName: 'Active',            
            field: 'isActive',
            flex: 1,
            maxWidth: 60,
            cellRenderer: "CheckboxCellComponent",
            cellRendererParams: (params: any) => {
              return {
                value: params.data.isActive,
                isDisabled: true,
                onChange: (newValue: boolean) => {
                  params.data.isActive = newValue;
                }
              }
            },
            cellStyle: { "text-align": "center","line-height": "24px" }
        },
        {
            headerName: 'Title',
            field: 'messageTitle',
            cellRenderer: "cellRendererFormatter",
            cellRendererParams: {
                link: (params: any) => {
                    return params.value != null && params.value.length > 0;
                },
                onClick: function (data: any) {
                    parent.update(data);
                }.bind(this),
            },
            flex: 2
        },
        {
            headerName: 'Expiration Date',
            field: 'expirationDate',
            flex: 1,
            cellRenderer: "cellRendererFormatter",
            cellRendererParams: {type: "date", format: "MM/dd/yyyy"}
        },
        {
            headerName: 'Created By',
            field: 'createdBy',
            flex: 1,
            cellRenderer: "TruncateTooltipCellComponent"
        },
        {
            headerName: 'Created Date',
            field: 'createdDate',
            flex: 1,
            cellRenderer: "cellRendererFormatter",
            cellRendererParams: {type: "date", format: "MM/dd/yyyy"}
        },
        {
            headerName: 'Modified By',
            field: 'modifiedBy',
            flex: 1,
            cellRenderer: "TruncateTooltipCellComponent"
        },
        {
            headerName: 'Modified Date',
            field: 'modifiedDate',
            flex: 1,
            cellRenderer: "cellRendererFormatter",
            cellRendererParams: {type: "date", format: "MM/dd/yyyy"}
        }];
    }
}
